module.exports = __webpack_public_path__ + "img/bg28.6af9e1b7.png";